import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup } from "@angular/forms";

import { MainConfig, FormToolsService } from "@atenea-cms";
import { Category, CategoryService } from "../../categories/shared";
import { FilterService, FilterFormService } from "../shared";

@Component({
  selector: "filter-form",
  templateUrl: "./filter-form.component.html",
  styleUrls: ["./filter-form.component.scss"],
})
export class FilterFormComponent implements OnInit {
  loading: boolean = false;
  form: FormGroup;
  categories: Array<Category> = [];

  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    public ft: FormToolsService,
    public mainConfig: MainConfig,
    private categoryService: CategoryService,
    private filterService: FilterService,
    private formService: FilterFormService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Filtros - " + this.mainConfig.cmsName);
    this.loading = true;

    this.route.params.subscribe((params) => {
      this.categoryService.getAll().subscribe((categories) => {
        this.categories = categories;

        if (params["id"]) {
          this.filterService.getById(params["id"]).subscribe((item) => {
            this.form = this.formService.getForm(item);
            this.loading = false;
          });
        } else {
          this.form = this.formService.getForm();
          this.loading = false;
        }
      });
    });
  }

  refresh(id) {
    this.router.navigate(["/filters/" + id]);
  }

  goToBack() {
    this.router.navigate(["/filters"]);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/filter-form/filter-form.component.ts